export default __webpack_public_path__ + "10201f6.png";